
export const standardSsrRoutes: string[] = [
  '',
  '/',
  '/b/*',
  '/e/*',
  '/p/*',
  '/artist/*',
  '/brand/*',
  '/organizer/*',
  '/festival/*',
  '/news/*', '/hirfolyam/*',
  '/discover/*', '/felfedezo/*',
  '/data-deletion',
  '/cookies-policy',
  '/egyfeszt-foglalasi-fizetesi-feltetelek',
  '/terms-and-conditions',
  '/szerzodesi-feltetelek',
  '/altalanos-szerzodesi-feltetelek',
  '/privacy-policy',
  '/adatvedelmi-nyilatkozat',
  '/privacy-policy-hu',
];

export const ticketSsrRoutes: string[] = [
  '',
  '/',
  '/*',
  '/artist/*',
  '/brand/*',
  '/organizer/*',
  '/data-deletion',
  '/cookies-policy',
  '/egyfeszt-foglalasi-fizetesi-feltetelek',
  '/terms-and-conditions',
  '/szerzodesi-feltetelek',
  '/altalanos-szerzodesi-feltetelek',
  '/privacy-policy',
  '/adatvedelmi-nyilatkozat',
  '/privacy-policy-hu',
];

export const siofokSsrRoutes: string[] = [
  '/b/*',
  '/e/*',
  '/artist/*',
  '/brand/*',
  '/organizer/*',
  '/data-deletion',
  '/cookies-policy',
  '/egyfeszt-foglalasi-fizetesi-feltetelek',
  '/terms-and-conditions',
  '/szerzodesi-feltetelek',
  '/altalanos-szerzodesi-feltetelek',
  '/privacy-policy',
  '/adatvedelmi-nyilatkozat',
  '/privacy-policy-hu',
];

export const embeddedSsrRoutes: string[] = [
  '/b/*',
  '/e/*',
  '/privacy-policy',
  '/terms-and-conditions',
];
